#import "../../../streams/graphql/fragments/LiveInputMonitoringFragment.graphql"

query StreamEntrypointMonitoring($id: ID!, $from: DateTime!, $to: DateTime!) {
  streamEntrypoint(id: $id) {
    id
    signal {
      state
      since
      checkedAt
    }
    stream {
      id
      viewersOnline
    }
    monitoring(from: $from, to: $to) {
      ...LiveInputMonitoringFields
    }
  }
}
